/* eslint-disable no-undef */
import * as Sentry from '@sentry/browser';
import { config } from '../../config';

// version and environment are defined in the webpack.define plugin
// Hack to prevent test setup from failing
const getSafeVersion = () => {
    try {
        return SERVICE_VERSION;
    } catch (e) {
        return 'Test';
    }
};

const getSafeEnvironment = () => {
    try {
        return SERVICE_ENVIRONMENT;
    } catch (e) {
        return 'Test';
    }
};

const release = getSafeVersion();
const environment = getSafeEnvironment();
const isProduction = environment === 'production';

// should have been called before using it here
// ideally before even rendering your react app
Sentry.init({
    dsn: isProduction ? config.sentryToken : null,
    environment,
    release,
});

export const reportErrorToSentry = (...args) => {
    Sentry.captureException(...args);
    console.error(...args);
};

const MODULE_NAME = 'web-timed';

export const sendErrorToSentry = (exception) => {
    reportErrorToSentry(exception, {
        tags: {
            module: MODULE_NAME,
        },
    });
};
